import { sha256Base64Url } from '../crypto/hash';
import { normalizeOriginPathUrl } from '../url/normalize';

export const AUTO_VIDEO_KEY_PREFIX = 'v1u_';
export const AUTO_VIDEO_KEY_HASH_LENGTH = 43;

export function normalizeVideoSourceUrl(
  sourceUrl: string | null,
  options: { pageHref?: string } = {},
): string | null {
  if (!sourceUrl) return null;
  return normalizeOriginPathUrl(sourceUrl, options);
}

export async function createAutoVideoKey(
  sourceUrl: string,
  options: { pageHref?: string } = {},
): Promise<string> {
  const normalized = normalizeVideoSourceUrl(sourceUrl, options);
  if (!normalized) throw new Error('invalid_video_source_url');

  return `${AUTO_VIDEO_KEY_PREFIX}${(await sha256Base64Url(normalized)).slice(0, AUTO_VIDEO_KEY_HASH_LENGTH)}`;
}
